module.exports = __webpack_public_path__ + "6d3c7040b08ef9746c96ab4ef4d8f1e0.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/15/Bonnierforlagen_case_study.png
// module id = 241
// module chunks = 0